import { render, staticRenderFns } from "./layout404.vue?vue&type=template&id=327a53ab"
import script from "./layout404.vue?vue&type=script&lang=js"
export * from "./layout404.vue?vue&type=script&lang=js"
import style0 from "./layout404.vue?vue&type=style&index=0&id=327a53ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports